/**
 * "This manual was just made" — the create drawer marks it right before opening the editor, and the editor gives the new
 * manual its first section and step (owner 2026-11-04). Per tab (sessionStorage), so an existing empty manual opened
 * elsewhere is never seeded. The mark is cleared only once BOTH writes have landed: a reload in between finds it again and
 * finishes the job, instead of leaving the manual empty or with a section but no step (diff-panel 2026-11-04).
 */
const key = (manualId: number) => `arc_editor_seed_${manualId}`;

export function markNewManual(manualId: number): void {
  try {
    window.sessionStorage.setItem(key(manualId), "1");
  } catch {
    // Without storage the new manual simply opens empty.
  }
}

export function hasNewManualMark(manualId: number): boolean {
  try {
    return window.sessionStorage.getItem(key(manualId)) === "1";
  } catch {
    return false;
  }
}

export function clearNewManualMark(manualId: number): void {
  try {
    window.sessionStorage.removeItem(key(manualId));
  } catch {
    // Nothing stored, nothing to clear.
  }
}
